import React, { useState, useEffect } from 'react';
import {useLocalStorage} from '../utils/hooks';
import {useNavigate} from 'react-router-dom';
import {LOCAL_STORAGE_KEY} from '../constants/localStorage';
import { useZulassung } from './zulassungs-context';

const NotificationContext = React.createContext();

const NotificationProvider = (props) => {
  const [notificationToken, setNotificationToken] = useState('');
  const {updateMandant} = useZulassung();
  const navigate = useNavigate();

  useEffect(() => {
    function firebaseSetup() {
      // We use FCM only for Android. For iOS - we use plain APNS
        window.FirebasePlugin.onTokenRefresh(fcmToken => {
          setNotificationToken(fcmToken);
          console.log(fcmToken);
        }, error => {
          console.error(error);
        });
      /*
      // iOS device token
      window.FirebasePlugin.onApnsTokenReceived(apnsToken => {
        setNotificationToken(apnsToken);
        console.log(apnsToken);
      }, error => {
        console.error(error);
      });
      */
      window.FirebasePlugin.onMessageReceived(message => {
        console.log(message.client);
        console.log(message.path);
        if (message.tap) {
          if (message.client) {
            updateMandant(message.client);
          }
          if (message.path) {
            navigate(message.path);
          }  
        }
      }, error => {
        console.error(error);
      });  
    }
    if (window.cordova) {
      if (window.cordova?.platformId === 'ios') {
        window.FirebasePlugin.setBadgeNumber(0);
        try {
          window.FirebasePlugin.grantPermission(hasPermission => {
            console.log("Permission was " + (hasPermission ? "granted" : "denied"));
          });
          firebaseSetup();
        } catch (e) {
          console.error("FirebasePlugin grantPermission error", e);
        }
      } else {
        firebaseSetup();
      }
    }
  }, [navigate, updateMandant]);


  return <NotificationContext.Provider value={notificationToken}>{props.children}</NotificationContext.Provider>
}

const useNotification = () => {
  const context = React.useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useMessage must be used within a MessageProvider');
  }
    return context;
}

export {NotificationProvider, useNotification}